import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from "src/app/core/services/requests.service";

@Injectable({
  providedIn: 'root'
})
export class CargueService {
  // ENDPOINT = "http://127.0.0.1:8000/credito/lifemiles";
  requestsService: any;
  ENDPOINT = getEndpoint('lifeMiles');
  constructor(private _http: HttpClient, private _http2: RequestsService) { }

  transformEtiquetasToInsert(etiquetas: CargueV[]) {
    return etiquetas ? etiquetas.map((value, index) => {
      value["c_emp"] = getConnection();
      return value;
    }) : []
  }

  async cargue(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/cargue_lifemiles/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }
}

export class CargueV {
  membershipNumber: string;
  documentNumber: string;
  transactionDate: string;
  processDate: string;
  pointType: string;
  pointTypeName: string;
  bonusCode: string;
  bonusName: string;
  transactionType: string;
  ghost: string;
  noVoucher: string;
  originVoucher: string;
  authorizationNumber: string;
  originAuthorizationNumber: string;
  localAmount: string;
  miles: string;
  exchangeRate: string;
  milePrice: string;
  storeCode: string;
  storeName: string;
  cashierCode: string;
  rewardCode: string;
  activityNumber: string;
  activityReferenceNumber: string;
  senderCode: string;
}
